import type {Level} from 'shells/status-badge/status-badge';

export function getStatusBadgeInfo(status: string):
    | {
          level: Level;
          text: string;
      }
    | null
    | undefined {
    switch (status) {
        case 'SCHEDULED':
            return {level: 'info', text: 'Scheduled'};
        case 'ACTIVE':
            return {level: 'info--grey', text: 'Past'};
        case 'CANCELLED':
            return {level: 'warning', text: 'Cancelled'};
        default:
            return null;
    }
}

export function getIsScheduled(status: string): boolean {
    return status === 'SCHEDULED';
}
